import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../common/global";
import { HttpParams } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-vending-donation-transaction",
  templateUrl: "./vending-donation-transaction.component.html",
  styleUrls: ["./vending-donation-transaction.component.css"],
})
export class VendingDonationTransactionComponent implements OnInit {
  donation: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  currency: string = localStorage.getItem("CUR") || "SEK";
  loading: boolean = false;

  constructor(
    private router: Router,
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.getDonation();
  }

  getDonation(): void {
    this.loading = true;
    const user_id = this.globals.user._id;
    const pageIndex = this.page > 0 ? this.page - 1 : 0;

    let params = new HttpParams()
      .set("operator_id", user_id)
      .set("page", pageIndex.toString())
      .set("limit", this.pageSize.toString());

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        `${ConfigApi.URLS.VENDING_DONATION_TRANSACTION.LIST
        }?${params.toString()}`
      )
      .subscribe(
        (res) => {
          this.loading = false;
          if (this.apiCallingService.handleSuccess(res)) {
            this.donation = res.data;
            this.totalCount = res.total;
          }
        },
        (error) => {
          this.loading = false;
          this.toastr.error("Failed to load donations");
        }
      );
  }

  loadPage(page: number): void {
    if (page) {
      this.page = page;
      this.getDonation();
    }
  }

  viewDonationDetails(val: any): void {
    this.router.navigate(["/user/charity-transaction", val._id]);
  }
}
